import React, { FC } from 'react';
import { styled } from 'linaria/react';
import { Icon, Text } from '@mtsbank/ui-kit';
import { withTheme } from '@shared/lib';
interface IconWithLabelProps {
  label: string;
}
export const IconWithLabel: FC<IconWithLabelProps> = ({
  label
}) => <WrapperLabel>
    <Text size="md" color="inherit">
      {label}
    </Text>
    <Icon icon="baseX24/arrowDown" />
  </WrapperLabel>;
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.white;
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.state.active;
const WrapperLabel = withTheme(/*#__PURE__*/styled('li')({
  name: "WrapperLabel",
  class: "wld50cg",
  propsAsIs: false,
  vars: {
    "wld50cg-0": [_exp()],
    "wld50cg-1": [_exp2()]
  }
}));

require("./IconWithLabel.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./IconWithLabel.tsx");